import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { ignoreElements } from 'rxjs-compat/operator/ignoreElements';
import { FieldConfig } from '../field.interface';
import { Constant } from 'src/app/constants/constant';
import { ProductListiingService } from 'src/app/services/product-listiing.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { SubscriptionPriceService } from 'src/app/services/subscription-price.service';

@Component({
  exportAs: "dynamicForm",
  selector: 'dynamic-form',
  templateUrl: './dynamic-form.component.html',
  styleUrls: ['./dynamic-form.component.scss']
})
export class DynamicFormComponent {
  @Input() fields: FieldConfig[] = [];
  @Input() layout: any = 2;
  @Input() gapBetweenImage: any = '5px';
  @Input() displayMobileImage: any = 2;
  @Input() mobileGapBetweenImage: any = 2;
  @Input() customField13: any = 0;
  @Input() customField5: any = 0;

  @Input() newFormField: any = 0;

  objectTobeDisplayed: any;

  minusValue: any = '2px';
  @Output() submit: EventEmitter<any> = new EventEmitter<any>();

  form: UntypedFormGroup;
  formInit: boolean = false;

  formInit1: boolean = false;

  enableConditionalField?: any;
  @Input() patchValueList: any[] = [];
  previousFormField: any;
  indexNew: number = 0;
  valuesInputed: any = [];
  dontDisplayBackButton: boolean = false; imageList: any = [];

  previousFormFieldsList: any[] = [];

  text: string;
  initSecondForm: boolean = false;
  formInitSecond: boolean = false;
  EnablePayment: any;

  get value() {
    return this.form.value;
  }

  constructor(private fb: UntypedFormBuilder,
    private snackBar: MatSnackBar,
    private router: Router,
    private productListiingService: ProductListiingService,
    private subscriptionService : SubscriptionPriceService
  ) { }

  reInit: any = true;
  excludedInputTypes: Set<string> = new Set(['text']); 
  value1:any=[
    {
        "fieldId": 139,
        "label": "Vehicle Number ",
        "name": "vehicleNumber",
        "inputType": "text",
        "options": "",
        "collections": null,
        "type": "",
        "width": "",
        "value": null,
        "position": "",
        "customfield1": "1",
        "customfield2": "",
        "customfield3": "",
        "customfield4": "",
        "customfield5": "",
        "validations": null,
        "typeId": 1,
        "conditionText": "",
        "enableConditionalField": 0,
        "metaData": "{\"statement\":{\"groups\":[{\"conjunctor\":\"AND\",\"conditions\":[{\"filedName\":\"\",\"operators\":\"\",\"fieldValue\":\"\"}],\"groups\":[]}]}}",
        "gaTrackingId": null,
        "dynamicFormLabelValidator": [
            {
                "entityId": 143,
                "parentId": 139,
                "name": "",
                "validator": "",
                "message": "",
                "hintMessage": ""
            }
        ],
        "operationType": null
    },
    {
        "fieldId": 128,
        "label": "Select Vehicle Type",
        "name": "Select Vehicle Type",
        "inputType": "image",
        "options": "car,truck,bike",
        "collections": null,
        "type": "",
        "width": "",
        "value": null,
        "position": "",
        "customfield1": "1",
        "customfield2": "[{\"value\":\"car\",\"image\":\"Car.png\"},{\"value\":\"truck\",\"image\":\"Truck.png\"},{\"value\":\"bike\",\"image\":\"Bike.png\"}]",
        "customfield3": "1,Bike.png",
        "customfield4": "",
        "customfield5": "",
        "validations": null,
        "typeId": 1,
        "conditionText": "vehicleNumber.length =='10'",
        "enableConditionalField": 1,
        "metaData": "{\"statement\":{\"groups\":[{\"conjunctor\":\"OR\",\"conditions\":[{\"filedName\":\"vehicleNumber.length\",\"operators\":\"==\",\"fieldValue\":\"10\"}],\"groups\":[]}]}}",
        "gaTrackingId": null,
        "dynamicFormLabelValidator": [
            {
                "entityId": 132,
                "parentId": 128,
                "name": "",
                "validator": "",
                "message": "",
                "hintMessage": ""
            }
        ],
        "operationType": null
    },
    {
        "fieldId": 141,
        "label": "Model of the nissan car",
        "name": "Model of the nissan car",
        "inputType": "image",
        "options": "Kicks,Magnite,Others",
        "collections": null,
        "type": "",
        "width": "",
        "value": null,
        "position": "",
        "customfield1": "1",
        "customfield2": "[{\"value\":\"Kicks\",\"image\":\"Kicks.png\"},{\"value\":\"Magnite\",\"image\":\"Magnite.png\"},{\"value\":\"Others\",\"image\":\"Others.png\"}]",
        "customfield3": "1,Others.png",
        "customfield4": "",
        "customfield5": "",
        "validations": null,
        "typeId": 1,
        "conditionText": "Brand Of The Car =='Nissan'",
        "enableConditionalField": 1,
        "metaData": "{\"statement\":{\"groups\":[{\"conjunctor\":\"OR\",\"conditions\":[{\"filedName\":\"Brand Of The Car\",\"operators\":\"==\",\"fieldValue\":\"Nissan\"}],\"groups\":[]}]}}",
        "gaTrackingId": null,
        "dynamicFormLabelValidator": [
            {
                "entityId": 145,
                "parentId": 141,
                "name": "",
                "validator": "",
                "message": "",
                "hintMessage": ""
            }
        ],
        "operationType": null
    },
    {
        "fieldId": 142,
        "label": "Model of the renault car",
        "name": "Model of the renault car",
        "inputType": "image",
        "options": "Duster,Kiger,Kwid,Triber,Others",
        "collections": null,
        "type": "",
        "width": "",
        "value": null,
        "position": "",
        "customfield1": "1",
        "customfield2": "[{\"value\":\"Duster\",\"image\":\"Duster.png\"},{\"value\":\"Kiger\",\"image\":\"Kiger.png\"},{\"value\":\"Kwid\",\"image\":\"Kwid.png\"},{\"value\":\"Triber\",\"image\":\"Triber.png\"},{\"value\":\"Others\",\"image\":\"Others.png\"}]",
        "customfield3": "1,Others.png",
        "customfield4": "",
        "customfield5": "",
        "validations": null,
        "typeId": 1,
        "conditionText": "Brand Of The Car =='Renault'",
        "enableConditionalField": 1,
        "metaData": "{\"statement\":{\"groups\":[{\"conjunctor\":\"OR\",\"conditions\":[{\"filedName\":\"Brand Of The Car\",\"operators\":\"==\",\"fieldValue\":\"Renault\"}],\"groups\":[]}]}}",
        "gaTrackingId": null,
        "dynamicFormLabelValidator": [
            {
                "entityId": 146,
                "parentId": 142,
                "name": "",
                "validator": "",
                "message": "",
                "hintMessage": ""
            }
        ],
        "operationType": null
    },
    {
        "fieldId": 143,
        "label": "Model of the tata car",
        "name": "Model of the tata car",
        "inputType": "image",
        "options": "Indigo eCS,Nexon EV Max,Nexon EV Prime,Nexon EV,Nexon,Punch,Safari Tiago EV,Tiago NRG,Tiago,Tigor,Tigor EV,Altroz,Harrier,Others",
        "collections": null,
        "type": "",
        "width": "",
        "value": null,
        "position": "",
        "customfield1": "1",
        "customfield2": "[{\"value\":\"Indigo eCS\",\"image\":\"IndigoECS.png\"},{\"value\":\"Nexon EV Max\",\"image\":\"NexonEVMax.png\"},{\"value\":\"Nexon EV Prime\",\"image\":\"NexonEVPrime.png\"},{\"value\":\"Nexon EV\",\"image\":\"NexonEV.png\"},{\"value\":\"Nexon\",\"image\":\"Nexon.png\"},{\"value\":\"Punch\",\"image\":\"Punch.png\"},{\"value\":\"Safari Tiago EV\",\"image\":\"SafariTiagoEV.png\"},{\"value\":\"Tiago NRG\",\"image\":\"TiagoNRG.png\"},{\"value\":\"Tiago\",\"image\":\"Tiago.png\"},{\"value\":\"Tigor\",\"image\":\"Tigor.png\"},{\"value\":\"Tigor EV\",\"image\":\"TigorEV.png\"},{\"value\":\"Altroz\",\"image\":\"Altroz.png\"},{\"value\":\"Harrier\",\"image\":\"Harrier.png\"},{\"value\":\"Others\",\"image\":\"Others.png\"}]",
        "customfield3": "1,Others.png",
        "customfield4": "",
        "customfield5": "",
        "validations": null,
        "typeId": 1,
        "conditionText": "Brand Of The Car =='TATA' or tata =='owener details'",
        "enableConditionalField": 1,
        "metaData": "{\"statement\":{\"groups\":[{\"conjunctor\":\"OR\",\"conditions\":[{\"filedName\":\"Brand Of The Car\",\"operators\":\"==\",\"fieldValue\":\"TATA\"},{\"filedName\":\"tata\",\"operators\":\"==\",\"fieldValue\":\"owener details\"}],\"groups\":[]}]}}",
        "gaTrackingId": null,
        "dynamicFormLabelValidator": [
            {
                "entityId": 147,
                "parentId": 143,
                "name": "",
                "validator": "",
                "message": "",
                "hintMessage": ""
            }
        ],
        "operationType": null
    },
    {
        "fieldId": 144,
        "label": "Model of the toyota car",
        "name": "Model of the toyota car",
        "inputType": "image",
        "options": "Camry,Fortuner,Glanza,Hilux,Innova Crysta,Innova Hycross,Others",
        "collections": null,
        "type": "",
        "width": "",
        "value": null,
        "position": "",
        "customfield1": "1",
        "customfield2": "[{\"value\":\"Camry\",\"image\":\"camry.png\"},{\"value\":\"Fortuner\",\"image\":\"fortuner.png\"},{\"value\":\"Glanza\",\"image\":\"glanza.png\"},{\"value\":\"Hilux\",\"image\":\"hilux.png\"},{\"value\":\"Innova Crysta\",\"image\":\"innovacrysta.png\"},{\"value\":\"Innova Hycross\",\"image\":\"innovahycross.png\"},{\"value\":\"Others\",\"image\":\"Others.png\"}]",
        "customfield3": "1,Others.png",
        "customfield4": "",
        "customfield5": "",
        "validations": null,
        "typeId": 1,
        "conditionText": "Brand Of The Car =='Toyota'",
        "enableConditionalField": 1,
        "metaData": "{\"statement\":{\"groups\":[{\"conjunctor\":\"OR\",\"conditions\":[{\"filedName\":\"Brand Of The Car\",\"operators\":\"==\",\"fieldValue\":\"Toyota\"}],\"groups\":[]}]}}",
        "gaTrackingId": null,
        "dynamicFormLabelValidator": [
            {
                "entityId": 148,
                "parentId": 144,
                "name": "",
                "validator": "",
                "message": "",
                "hintMessage": ""
            }
        ],
        "operationType": null
    },
    {
        "fieldId": 177,
        "label": "Model of the Maruti Suzuki Car",
        "name": "Model of the Maruti Suzuki Car",
        "inputType": "image",
        "options": "Alto 800,Baleno,Ciaz,Swift,Wagon R 1.0,Others",
        "collections": null,
        "type": "",
        "width": "",
        "value": null,
        "position": "",
        "customfield1": "1",
        "customfield2": "[{\"value\":\"Alto 800\",\"image\":\"Alto.png\"},{\"value\":\"Baleno\",\"image\":\"Baleno.png\"},{\"value\":\"Ciaz\",\"image\":\"ciaz.png\"},{\"value\":\"Swift\",\"image\":\"swift.png\"},{\"value\":\"Wagon R 1.0\",\"image\":\"WagonR1.0.png\"},{\"value\":\"Others\",\"image\":\"Others.png\"}]",
        "customfield3": "1,Others.png",
        "customfield4": "",
        "customfield5": "",
        "validations": null,
        "typeId": 1,
        "conditionText": "Brand Of The Car =='Maruti Suzuki Car'",
        "enableConditionalField": 1,
        "metaData": "{\"statement\":{\"groups\":[{\"conjunctor\":\"AND\",\"conditions\":[{\"filedName\":\"Brand Of The Car\",\"operators\":\"==\",\"fieldValue\":\"Maruti Suzuki Car\"}],\"groups\":[]}]}}",
        "gaTrackingId": null,
        "dynamicFormLabelValidator": [
            {
                "entityId": 181,
                "parentId": 177,
                "name": "",
                "validator": "",
                "message": "",
                "hintMessage": ""
            }
        ],
        "operationType": null
    },
    {
        "fieldId": 166,
        "label": "Fuel Type",
        "name": "Fuel Type",
        "inputType": "image",
        "options": "CNG,Diesel,Petrol",
        "collections": null,
        "type": "",
        "width": "",
        "value": null,
        "position": "",
        "customfield1": "1",
        "customfield2": "[{\"value\":\"CNG\",\"image\":\"CNG.jpg\"},{\"value\":\"Diesel\",\"image\":\"Diesel.jpg\"},{\"value\":\"Petrol\",\"image\":\"Petrol.jpg\"}]",
        "customfield3": "1,Petrol.jpg",
        "customfield4": "",
        "customfield5": "",
        "validations": null,
        "typeId": 1,
        "conditionText": "Transmission =='Automatic gear' or Transmission =='Manual gear'",
        "enableConditionalField": 1,
        "metaData": "{\"statement\":{\"groups\":[{\"conjunctor\":\"OR\",\"conditions\":[{\"filedName\":\"Transmission\",\"operators\":\"==\",\"fieldValue\":\"Automatic gear\"},{\"filedName\":\"Transmission\",\"operators\":\"==\",\"fieldValue\":\"Manual gear\"}],\"groups\":[]}]}}",
        "gaTrackingId": null,
        "dynamicFormLabelValidator": [
            {
                "entityId": 170,
                "parentId": 166,
                "name": "",
                "validator": "",
                "message": "",
                "hintMessage": ""
            }
        ],
        "operationType": null
    },
    {
        "fieldId": 167,
        "label": "Transmission",
        "name": "Transmission",
        "inputType": "image",
        "options": "Automatic gear,Manual gear",
        "collections": null,
        "type": "",
        "width": "",
        "value": null,
        "position": "",
        "customfield1": "1",
        "customfield2": "[{\"value\":\"Automatic gear\",\"image\":\"Automaticgear.jpg\"},{\"value\":\"Manual gear\",\"image\":\"Manualgear.jpg\"}]",
        "customfield3": "1,Manualgear.jpg",
        "customfield4": "",
        "customfield5": "",
        "validations": null,
        "typeId": 1,
        "conditionText": "Model of the nissan car =='Magnite' or Model of the nissan car =='Kicks' or Model of the nissan car =='Others' or Model of the renault car =='Kwid' or Model of the renault car =='Triber' or Model of the renault car =='Duster' or Model of the renault car =='Others' or Model of the tata car =='Tiago NRG' or Model of the tata car =='Tiago' or Model of the tata car =='Nexon' or Model of the tata car =='Altroz' or Model of the tata car =='Tigor' or Model of the tata car =='Harrier' or Model of the tata car =='Indica Vista' or Model of the tata car =='Indigo eCS' or Model of the tata car =='Nexon EV' or Model of the tata car =='Nexon EV Max' or Model of the tata car =='Nexon EV Prime' or Model of the tata car =='Punch' or Model of the tata car =='Safari Tiago EV' or Model of the tata car =='Tigor EV' or Model of the tata car =='Others' or Model of the toyota car =='Urban Cruiser Hyryder' or Model of the toyota car =='Glanza' or Model of the toyota car =='Innova Crysta' or Model of the toyota car =='Camry' or Model of the toyota car =='Fortuner' or Model of the toyota car =='Hilux' or Model of the toyota car =='Innova' or Model of the toyota car =='Hycross' or Model of the toyota car =='Rumion' or Model of the toyota car =='Others' or Model of the Maruti Suzuki Car =='Wagon R 1.0' or Model of the Maruti Suzuki Car =='Swift' or Model of the Maruti Suzuki Car =='Baleno' or Model of the Maruti Suzuki Car =='Alto 800' or Model of the Maruti Suzuki Car =='Ciaz' or Model of the Maruti Suzuki Car =='Others' or Model of the audi car =='A4' or Model of the audi car =='others' or Model of the audi car =='Q7' or Model of the audi car =='Q2' or Model of the audi car =='A6' or Model of the audi car =='Q3' or Model of the benz car =='others' or Model of the benz car =='C-Class' or Model of the benz car =='E-Class' or Model of the benz car =='GLS' or Model of the benz car =='GLE' or Model of the benz car =='GLB' or Model of the benz car =='A-Class' or Model of the benz car =='GLC' or Model of the benz car =='GLA' or Model of the bmw car =='X4' or Model of the bmw car =='7 Series' or Model of the bmw car =='5 Series' or Model of the bmw car =='X3' or Model of the bmw car =='1 Series' or Model of the bmw car =='2 Series Gran Coupe' or Model of the bmw car =='6 Series' or Model of the bmw car =='X1' or Model of the bmw car =='3 Series' or Model of the bmw car =='8 Series' or Model of the bmw car =='other' or Model of the bmw car =='X5' or Model of the ford car =='EcoSport' or Model of the ford car =='others' or Model of the ford car =='Freestyle' or Model of the ford car =='Figo' or Model of the ford car =='Figo Aspire' or Model of the kia car =='Seltos' or Model of the kia car =='others' or Model of the kia car =='Carnival' or Model of the kia car =='Carens' or Model of the kia car =='Sonet' or Model of the mahindra car =='XUV 300 TurboSport' or Model of the mahindra car =='Scorpio N' or Model of the mahindra car =='KUV100' or Model of the mahindra car =='Bolero' or Model of the mahindra car =='XUV700' or Model of the mahindra car =='Bolero Neo' or Model of the mahindra car =='KUV100 NXT' or Model of the mahindra car =='XUV 300' or Model of the mahindra car =='Thar' or Model of the mahindra car =='Marazzo' or Model of the mahindra car =='Scorpio Classic' or Model of the mahindra car =='Others' or Model of the renault car =='Kiger'",
        "enableConditionalField": 1,
        "metaData": "{\"statement\":{\"groups\":[{\"conjunctor\":\"OR\",\"conditions\":[{\"filedName\":\"Model of the nissan car\",\"operators\":\"==\",\"fieldValue\":\"Magnite\"},{\"filedName\":\"Model of the nissan car\",\"operators\":\"==\",\"fieldValue\":\"Kicks\"},{\"filedName\":\"Model of the nissan car\",\"operators\":\"==\",\"fieldValue\":\"Others\"},{\"filedName\":\"Model of the renault car\",\"operators\":\"==\",\"fieldValue\":\"Kwid\"},{\"filedName\":\"Model of the renault car\",\"operators\":\"==\",\"fieldValue\":\"Triber\"},{\"filedName\":\"Model of the renault car\",\"operators\":\"==\",\"fieldValue\":\"Duster\"},{\"filedName\":\"Model of the renault car\",\"operators\":\"==\",\"fieldValue\":\"Others\"},{\"filedName\":\"Model of the tata car\",\"operators\":\"==\",\"fieldValue\":\"Tiago NRG\"},{\"filedName\":\"Model of the tata car\",\"operators\":\"==\",\"fieldValue\":\"Tiago\"},{\"filedName\":\"Model of the tata car\",\"operators\":\"==\",\"fieldValue\":\"Nexon\"},{\"filedName\":\"Model of the tata car\",\"operators\":\"==\",\"fieldValue\":\"Altroz\"},{\"filedName\":\"Model of the tata car\",\"operators\":\"==\",\"fieldValue\":\"Tigor\"},{\"filedName\":\"Model of the tata car\",\"operators\":\"==\",\"fieldValue\":\"Harrier\"},{\"filedName\":\"Model of the tata car\",\"operators\":\"==\",\"fieldValue\":\"Indica Vista\"},{\"filedName\":\"Model of the tata car\",\"operators\":\"==\",\"fieldValue\":\"Indigo eCS\"},{\"filedName\":\"Model of the tata car\",\"operators\":\"==\",\"fieldValue\":\"Nexon EV\"},{\"filedName\":\"Model of the tata car\",\"operators\":\"==\",\"fieldValue\":\"Nexon EV Max\"},{\"filedName\":\"Model of the tata car\",\"operators\":\"==\",\"fieldValue\":\"Nexon EV Prime\"},{\"filedName\":\"Model of the tata car\",\"operators\":\"==\",\"fieldValue\":\"Punch\"},{\"filedName\":\"Model of the tata car\",\"operators\":\"==\",\"fieldValue\":\"Safari Tiago EV\"},{\"filedName\":\"Model of the tata car\",\"operators\":\"==\",\"fieldValue\":\"Tigor EV\"},{\"filedName\":\"Model of the tata car\",\"operators\":\"==\",\"fieldValue\":\"Others\"},{\"filedName\":\"Model of the toyota car\",\"operators\":\"==\",\"fieldValue\":\"Urban Cruiser Hyryder\"},{\"filedName\":\"Model of the toyota car\",\"operators\":\"==\",\"fieldValue\":\"Glanza\"},{\"filedName\":\"Model of the toyota car\",\"operators\":\"==\",\"fieldValue\":\"Innova Crysta\"},{\"filedName\":\"Model of the toyota car\",\"operators\":\"==\",\"fieldValue\":\"Camry\"},{\"filedName\":\"Model of the toyota car\",\"operators\":\"==\",\"fieldValue\":\"Fortuner\"},{\"filedName\":\"Model of the toyota car\",\"operators\":\"==\",\"fieldValue\":\"Hilux\"},{\"filedName\":\"Model of the toyota car\",\"operators\":\"==\",\"fieldValue\":\"Innova\"},{\"filedName\":\"Model of the toyota car\",\"operators\":\"==\",\"fieldValue\":\"Hycross\"},{\"filedName\":\"Model of the toyota car\",\"operators\":\"==\",\"fieldValue\":\"Rumion\"},{\"filedName\":\"Model of the toyota car\",\"operators\":\"==\",\"fieldValue\":\"Others\"},{\"filedName\":\"Model of the Maruti Suzuki Car\",\"operators\":\"==\",\"fieldValue\":\"Wagon R 1.0\"},{\"filedName\":\"Model of the Maruti Suzuki Car\",\"operators\":\"==\",\"fieldValue\":\"Swift\"},{\"filedName\":\"Model of the Maruti Suzuki Car\",\"operators\":\"==\",\"fieldValue\":\"Baleno\"},{\"filedName\":\"Model of the Maruti Suzuki Car\",\"operators\":\"==\",\"fieldValue\":\"Alto 800\"},{\"filedName\":\"Model of the Maruti Suzuki Car\",\"operators\":\"==\",\"fieldValue\":\"Ciaz\"},{\"filedName\":\"Model of the Maruti Suzuki Car\",\"operators\":\"==\",\"fieldValue\":\"Others\"},{\"filedName\":\"Model of the audi car\",\"operators\":\"==\",\"fieldValue\":\"A4\"},{\"filedName\":\"Model of the audi car\",\"operators\":\"==\",\"fieldValue\":\"others\"},{\"filedName\":\"Model of the audi car\",\"operators\":\"==\",\"fieldValue\":\"Q7\"},{\"filedName\":\"Model of the audi car\",\"operators\":\"==\",\"fieldValue\":\"Q2\"},{\"filedName\":\"Model of the audi car\",\"operators\":\"==\",\"fieldValue\":\"A6\"},{\"filedName\":\"Model of the audi car\",\"operators\":\"==\",\"fieldValue\":\"Q3\"},{\"filedName\":\"Model of the benz car\",\"operators\":\"==\",\"fieldValue\":\"others\"},{\"filedName\":\"Model of the benz car\",\"operators\":\"==\",\"fieldValue\":\"C-Class\"},{\"filedName\":\"Model of the benz car\",\"operators\":\"==\",\"fieldValue\":\"E-Class\"},{\"filedName\":\"Model of the benz car\",\"operators\":\"==\",\"fieldValue\":\"GLS\"},{\"filedName\":\"Model of the benz car\",\"operators\":\"==\",\"fieldValue\":\"GLE\"},{\"filedName\":\"Model of the benz car\",\"operators\":\"==\",\"fieldValue\":\"GLB\"},{\"filedName\":\"Model of the benz car\",\"operators\":\"==\",\"fieldValue\":\"A-Class\"},{\"filedName\":\"Model of the benz car\",\"operators\":\"==\",\"fieldValue\":\"GLC\"},{\"filedName\":\"Model of the benz car\",\"operators\":\"==\",\"fieldValue\":\"GLA\"},{\"filedName\":\"Model of the bmw car\",\"operators\":\"==\",\"fieldValue\":\"X4\"},{\"filedName\":\"Model of the bmw car\",\"operators\":\"==\",\"fieldValue\":\"7 Series\"},{\"filedName\":\"Model of the bmw car\",\"operators\":\"==\",\"fieldValue\":\"5 Series\"},{\"filedName\":\"Model of the bmw car\",\"operators\":\"==\",\"fieldValue\":\"X3\"},{\"filedName\":\"Model of the bmw car\",\"operators\":\"==\",\"fieldValue\":\"1 Series\"},{\"filedName\":\"Model of the bmw car\",\"operators\":\"==\",\"fieldValue\":\"2 Series Gran Coupe\"},{\"filedName\":\"Model of the bmw car\",\"operators\":\"==\",\"fieldValue\":\"6 Series\"},{\"filedName\":\"Model of the bmw car\",\"operators\":\"==\",\"fieldValue\":\"X1\"},{\"filedName\":\"Model of the bmw car\",\"operators\":\"==\",\"fieldValue\":\"3 Series\"},{\"filedName\":\"Model of the bmw car\",\"operators\":\"==\",\"fieldValue\":\"8 Series\"},{\"filedName\":\"Model of the bmw car\",\"operators\":\"==\",\"fieldValue\":\"other\"},{\"filedName\":\"Model of the bmw car\",\"operators\":\"==\",\"fieldValue\":\"X5\"},{\"filedName\":\"Model of the ford car\",\"operators\":\"==\",\"fieldValue\":\"EcoSport\"},{\"filedName\":\"Model of the ford car\",\"operators\":\"==\",\"fieldValue\":\"others\"},{\"filedName\":\"Model of the ford car\",\"operators\":\"==\",\"fieldValue\":\"Freestyle\"},{\"filedName\":\"Model of the ford car\",\"operators\":\"==\",\"fieldValue\":\"Figo\"},{\"filedName\":\"Model of the ford car\",\"operators\":\"==\",\"fieldValue\":\"Figo Aspire\"},{\"filedName\":\"Model of the kia car\",\"operators\":\"==\",\"fieldValue\":\"Seltos\"},{\"filedName\":\"Model of the kia car\",\"operators\":\"==\",\"fieldValue\":\"others\"},{\"filedName\":\"Model of the kia car\",\"operators\":\"==\",\"fieldValue\":\"Carnival\"},{\"filedName\":\"Model of the kia car\",\"operators\":\"==\",\"fieldValue\":\"Carens\"},{\"filedName\":\"Model of the kia car\",\"operators\":\"==\",\"fieldValue\":\"Sonet\"},{\"filedName\":\"Model of the mahindra car\",\"operators\":\"==\",\"fieldValue\":\"XUV 300 TurboSport\"},{\"filedName\":\"Model of the mahindra car\",\"operators\":\"==\",\"fieldValue\":\"Scorpio N\"},{\"filedName\":\"Model of the mahindra car\",\"operators\":\"==\",\"fieldValue\":\"KUV100\"},{\"filedName\":\"Model of the mahindra car\",\"operators\":\"==\",\"fieldValue\":\"Bolero\"},{\"filedName\":\"Model of the mahindra car\",\"operators\":\"==\",\"fieldValue\":\"XUV700\"},{\"filedName\":\"Model of the mahindra car\",\"operators\":\"==\",\"fieldValue\":\"Bolero Neo\"},{\"filedName\":\"Model of the mahindra car\",\"operators\":\"==\",\"fieldValue\":\"KUV100 NXT\"},{\"filedName\":\"Model of the mahindra car\",\"operators\":\"==\",\"fieldValue\":\"XUV 300\"},{\"filedName\":\"Model of the mahindra car\",\"operators\":\"==\",\"fieldValue\":\"Thar\"},{\"filedName\":\"Model of the mahindra car\",\"operators\":\"==\",\"fieldValue\":\"Marazzo\"},{\"filedName\":\"Model of the mahindra car\",\"operators\":\"==\",\"fieldValue\":\"Scorpio Classic\"},{\"filedName\":\"Model of the mahindra car\",\"operators\":\"==\",\"fieldValue\":\"Others\"},{\"filedName\":\"Model of the renault car\",\"operators\":\"==\",\"fieldValue\":\"Kiger\"}],\"groups\":[]}]}}",
        "gaTrackingId": null,
        "dynamicFormLabelValidator": [
            {
                "entityId": 171,
                "parentId": 167,
                "name": "",
                "validator": "",
                "message": "",
                "hintMessage": ""
            }
        ],
        "operationType": null
    },
    {
        "fieldId": 168,
        "label": "Select the kilometers",
        "name": "Select the kilometers",
        "inputType": "select",
        "options": "0 Km to10000 Km,10000 Km to 20000 Km,20000 Km to 30000 Km,30000 Km to 40000 Km,40000 Km to 50000 Km,60000 Km to 70000 Km,80000 Km to 90000 Km,90000 Km to 100000 Km,100000 Km to 125000 Km,125000 Km to 150000 Km,175000 Km to 200000 Km,200000 Km to 225000 Km,225000 Km to 250000 Km,250000 Km or more",
        "collections": null,
        "type": "",
        "width": "",
        "value": null,
        "position": "",
        "customfield1": "1",
        "customfield2": "",
        "customfield3": "",
        "customfield4": "",
        "customfield5": "",
        "validations": null,
        "typeId": 1,
        "conditionText": "Fuel Type =='CNG' or Fuel Type =='Diesel' or Fuel Type =='Petrol'",
        "enableConditionalField": 1,
        "metaData": "{\"statement\":{\"groups\":[{\"conjunctor\":\"OR\",\"conditions\":[{\"filedName\":\"Fuel Type\",\"operators\":\"==\",\"fieldValue\":\"CNG\"},{\"filedName\":\"Fuel Type\",\"operators\":\"==\",\"fieldValue\":\"Diesel\"},{\"filedName\":\"Fuel Type\",\"operators\":\"==\",\"fieldValue\":\"Petrol\"}],\"groups\":[]}]}}",
        "gaTrackingId": null,
        "dynamicFormLabelValidator": [
            {
                "entityId": 172,
                "parentId": 168,
                "name": "",
                "validator": "",
                "message": "",
                "hintMessage": ""
            }
        ],
        "operationType": null
    },
    {
        "fieldId": 169,
        "label": "When do you want to sell ?",
        "name": "When do you want to sell ?",
        "inputType": "select",
        "options": "Immediately,Within a month,After a month,Just checking price",
        "collections": null,
        "type": "",
        "width": "",
        "value": null,
        "position": "",
        "customfield1": "1",
        "customfield2": "",
        "customfield3": "",
        "customfield4": "",
        "customfield5": "",
        "validations": null,
        "typeId": 1,
        "conditionText": "Select the kilometers =='0Kmto10000Km' or Select the kilometers =='10000Kmto20000Km' or Select the kilometers =='20000Kmto30000Km' or Select the kilometers =='30000Kmto40000Km' or Select the kilometers =='40000Kmto50000Km' or Select the kilometers =='40000Kmto50000Km' or Select the kilometers =='60000Kmto70000Km' or Select the kilometers =='80000Kmto90000Km' or Select the kilometers =='90000Kmto100000Km' or Select the kilometers =='100000Kmto125000Km' or Select the kilometers =='125000Kmto150000Km' or Select the kilometers =='175000Kmto200000Km' or Select the kilometers =='200000Kmto225000Km' or Select the kilometers =='225000Kmto250000Km' or Select the kilometers =='250000Kmormore'",
        "enableConditionalField": 1,
        "metaData": "{\"statement\":{\"groups\":[{\"conjunctor\":\"OR\",\"conditions\":[{\"filedName\":\"Select the kilometers\",\"operators\":\"==\",\"fieldValue\":\"0Kmto10000Km\"},{\"filedName\":\"Select the kilometers\",\"operators\":\"==\",\"fieldValue\":\"10000Kmto20000Km\"},{\"filedName\":\"Select the kilometers\",\"operators\":\"==\",\"fieldValue\":\"20000Kmto30000Km\"},{\"filedName\":\"Select the kilometers\",\"operators\":\"==\",\"fieldValue\":\"30000Kmto40000Km\"},{\"filedName\":\"Select the kilometers\",\"operators\":\"==\",\"fieldValue\":\"40000Kmto50000Km\"},{\"filedName\":\"Select the kilometers\",\"operators\":\"==\",\"fieldValue\":\"40000Kmto50000Km\"},{\"filedName\":\"Select the kilometers\",\"operators\":\"==\",\"fieldValue\":\"60000Kmto70000Km\"},{\"filedName\":\"Select the kilometers\",\"operators\":\"==\",\"fieldValue\":\"80000Kmto90000Km\"},{\"filedName\":\"Select the kilometers\",\"operators\":\"==\",\"fieldValue\":\"90000Kmto100000Km\"},{\"filedName\":\"Select the kilometers\",\"operators\":\"==\",\"fieldValue\":\"100000Kmto125000Km\"},{\"filedName\":\"Select the kilometers\",\"operators\":\"==\",\"fieldValue\":\"125000Kmto150000Km\"},{\"filedName\":\"Select the kilometers\",\"operators\":\"==\",\"fieldValue\":\"175000Kmto200000Km\"},{\"filedName\":\"Select the kilometers\",\"operators\":\"==\",\"fieldValue\":\"200000Kmto225000Km\"},{\"filedName\":\"Select the kilometers\",\"operators\":\"==\",\"fieldValue\":\"225000Kmto250000Km\"},{\"filedName\":\"Select the kilometers\",\"operators\":\"==\",\"fieldValue\":\"250000Kmormore\"}],\"groups\":[]}]}}",
        "gaTrackingId": null,
        "dynamicFormLabelValidator": [
            {
                "entityId": 173,
                "parentId": 169,
                "name": "",
                "validator": "",
                "message": "",
                "hintMessage": ""
            }
        ],
        "operationType": null
    },
    {
        "fieldId": 179,
        "label": "upload image",
        "name": "upload image",
        "inputType": "file",
        "options": "",
        "collections": null,
        "type": "",
        "width": "",
        "value": null,
        "position": "",
        "customfield1": "1",
        "customfield2": "",
        "customfield3": "",
        "customfield4": "",
        "customfield5": "",
        "validations": null,
        "typeId": 1,
        "conditionText": "RC =='Yes' or RC =='No'",
        "enableConditionalField": 1,
        "metaData": "{\"statement\":{\"groups\":[{\"conjunctor\":\"OR\",\"conditions\":[{\"filedName\":\"RC\",\"operators\":\"==\",\"fieldValue\":\"Yes\"},{\"filedName\":\"RC\",\"operators\":\"==\",\"fieldValue\":\"No\"}],\"groups\":[]}]}}",
        "gaTrackingId": null,
        "dynamicFormLabelValidator": [
            {
                "entityId": 183,
                "parentId": 179,
                "name": "",
                "validator": "",
                "message": "",
                "hintMessage": ""
            }
        ],
        "operationType": null
    },
    {
        "fieldId": 129,
        "label": "Brand Of The Car",
        "name": "Brand Of The Car",
        "inputType": "image",
        "options": "AUDI,BENZ,BMW,Ford,KIA,Mahindra,Nissan,Renault,TATA,Toyota,Maruti Suzuki Car",
        "collections": null,
        "type": "",
        "width": "",
        "value": null,
        "position": "",
        "customfield1": "1",
        "customfield2": "[{\"value\":\"AUDI\",\"image\":\"AUDI.png\"},{\"value\":\"BENZ\",\"image\":\"BENZ.png\"},{\"value\":\"BMW\",\"image\":\"BMW.png\"},{\"value\":\"Ford\",\"image\":\"Ford.png\"},{\"value\":\"KIA\",\"image\":\"KIA.png\"},{\"value\":\"Mahindra\",\"image\":\"Mahindra.png\"},{\"value\":\"Nissan\",\"image\":\"Nissan.png\"},{\"value\":\"Renault\",\"image\":\"Renault.png\"},{\"value\":\"TATA\",\"image\":\"TATA.png\"},{\"value\":\"Toyota\",\"image\":\"Toyota.png\"},{\"value\":\"Maruti Suzuki Car\",\"image\":\"MarutiSuzuki.png\"}]",
        "customfield3": "1,MarutiSuzuki.png",
        "customfield4": "",
        "customfield5": "",
        "validations": null,
        "typeId": 1,
        "conditionText": "Select Vehicle Type =='car'",
        "enableConditionalField": 1,
        "metaData": "{\"statement\":{\"groups\":[{\"conjunctor\":\"OR\",\"conditions\":[{\"filedName\":\"Select Vehicle Type\",\"operators\":\"==\",\"fieldValue\":\"car\"}],\"groups\":[]}]}}",
        "gaTrackingId": null,
        "dynamicFormLabelValidator": [
            {
                "entityId": 133,
                "parentId": 129,
                "name": "",
                "validator": "",
                "message": "",
                "hintMessage": ""
            }
        ],
        "operationType": null
    },
    {
        "fieldId": 184,
        "label": "ownership history of the vehicle",
        "name": "ownership history of the vehicle",
        "inputType": "select",
        "options": "1st owner ,2nd owner ,3rd owner ,4th owner ,Beyond 4th owner",
        "collections": null,
        "type": "",
        "width": "",
        "value": null,
        "position": "",
        "customfield1": "1",
        "customfield2": "",
        "customfield3": "",
        "customfield4": "",
        "customfield5": "",
        "validations": null,
        "typeId": 1,
        "conditionText": "When do you want to sell ? =='Immediately' or When do you want to sell ? =='Within a month' or When do you want to sell ? =='After a month' or When do you want to sell ? =='Just checking price'",
        "enableConditionalField": 1,
        "metaData": "{\"statement\":{\"groups\":[{\"conjunctor\":\"OR\",\"conditions\":[{\"filedName\":\"When do you want to sell ?\",\"operators\":\"==\",\"fieldValue\":\"Immediately\"},{\"filedName\":\"When do you want to sell ?\",\"operators\":\"==\",\"fieldValue\":\"Within a month\"},{\"filedName\":\"When do you want to sell ?\",\"operators\":\"==\",\"fieldValue\":\"After a month\"},{\"filedName\":\"When do you want to sell ?\",\"operators\":\"==\",\"fieldValue\":\"Just checking price\"}],\"groups\":[]}]}}",
        "gaTrackingId": null,
        "dynamicFormLabelValidator": [
            {
                "entityId": 188,
                "parentId": 184,
                "name": "",
                "validator": "",
                "message": "",
                "hintMessage": ""
            }
        ],
        "operationType": null
    },
    {
        "fieldId": 172,
        "label": "Insurance",
        "name": "Insurance",
        "inputType": "select",
        "options": "Yes,No",
        "collections": null,
        "type": "",
        "width": "",
        "value": null,
        "position": "",
        "customfield1": "1",
        "customfield2": "",
        "customfield3": "",
        "customfield4": "",
        "customfield5": "",
        "validations": null,
        "typeId": 1,
        "conditionText": "ownership history of the vehicle =='1st owner' or ownership history of the vehicle =='2nd owner' or ownership history of the vehicle =='3rd owner' or ownership history of the vehicle =='4th owner' or ownership history of the vehicle =='Beyond 4th owner'",
        "enableConditionalField": 1,
        "metaData": "{\"statement\":{\"groups\":[{\"conjunctor\":\"OR\",\"conditions\":[{\"filedName\":\"ownership history of the vehicle\",\"operators\":\"==\",\"fieldValue\":\"1st owner\"},{\"filedName\":\"ownership history of the vehicle\",\"operators\":\"==\",\"fieldValue\":\"2nd owner\"},{\"filedName\":\"ownership history of the vehicle\",\"operators\":\"==\",\"fieldValue\":\"3rd owner\"},{\"filedName\":\"ownership history of the vehicle\",\"operators\":\"==\",\"fieldValue\":\"4th owner\"},{\"filedName\":\"ownership history of the vehicle\",\"operators\":\"==\",\"fieldValue\":\"Beyond 4th owner\"}],\"groups\":[]}]}}",
        "gaTrackingId": null,
        "dynamicFormLabelValidator": [
            {
                "entityId": 176,
                "parentId": 172,
                "name": "",
                "validator": "",
                "message": "",
                "hintMessage": ""
            }
        ],
        "operationType": null
    },
    {
        "fieldId": 173,
        "label": "NOC",
        "name": "NOC",
        "inputType": "select",
        "options": "Yes,No",
        "collections": null,
        "type": "",
        "width": "",
        "value": null,
        "position": "",
        "customfield1": "1",
        "customfield2": "",
        "customfield3": "",
        "customfield4": "",
        "customfield5": "",
        "validations": null,
        "typeId": 1,
        "conditionText": "Insurance =='Yes' or Insurance =='No'",
        "enableConditionalField": 1,
        "metaData": "{\"statement\":{\"groups\":[{\"conjunctor\":\"OR\",\"conditions\":[{\"filedName\":\"Insurance\",\"operators\":\"==\",\"fieldValue\":\"Yes\"},{\"filedName\":\"Insurance\",\"operators\":\"==\",\"fieldValue\":\"No\"}],\"groups\":[]}]}}",
        "gaTrackingId": null,
        "dynamicFormLabelValidator": [
            {
                "entityId": 177,
                "parentId": 173,
                "name": "",
                "validator": "",
                "message": "",
                "hintMessage": ""
            }
        ],
        "operationType": null
    },
    {
        "fieldId": 171,
        "label": "RC",
        "name": "RC",
        "inputType": "select",
        "options": "Yes,No",
        "collections": null,
        "type": "",
        "width": "",
        "value": null,
        "position": "",
        "customfield1": "1",
        "customfield2": "",
        "customfield3": "",
        "customfield4": "",
        "customfield5": "",
        "validations": null,
        "typeId": 1,
        "conditionText": "NOC =='Yes' or NOC =='No'",
        "enableConditionalField": 1,
        "metaData": "{\"statement\":{\"groups\":[{\"conjunctor\":\"OR\",\"conditions\":[{\"filedName\":\"NOC\",\"operators\":\"==\",\"fieldValue\":\"Yes\"},{\"filedName\":\"NOC\",\"operators\":\"==\",\"fieldValue\":\"No\"}],\"groups\":[]}]}}",
        "gaTrackingId": null,
        "dynamicFormLabelValidator": [
            {
                "entityId": 175,
                "parentId": 171,
                "name": "",
                "validator": "",
                "message": "",
                "hintMessage": ""
            }
        ],
        "operationType": null
    },
    {
        "fieldId": 185,
        "label": "Type of the truck",
        "name": "Type of the truck",
        "inputType": "image",
        "options": "mini truck,heavy truck,tipper",
        "collections": null,
        "type": "",
        "width": "",
        "value": null,
        "position": "",
        "customfield1": "1",
        "customfield2": "[{\"value\":\"mini truck\",\"image\":\"minitruck.png\"},{\"value\":\"heavy truck\",\"image\":\"heavytruck.png\"},{\"value\":\"tipper\",\"image\":\"tripper.png\"}]",
        "customfield3": "1,tripper.png",
        "customfield4": "",
        "customfield5": "",
        "validations": null,
        "typeId": 1,
        "conditionText": "Select Vehicle Type =='truck'",
        "enableConditionalField": 1,
        "metaData": "{\"statement\":{\"groups\":[{\"conjunctor\":\"OR\",\"conditions\":[{\"filedName\":\"Select Vehicle Type\",\"operators\":\"==\",\"fieldValue\":\"truck\"}],\"groups\":[]}]}}",
        "gaTrackingId": null,
        "dynamicFormLabelValidator": [
            {
                "entityId": 189,
                "parentId": 185,
                "name": "",
                "validator": "",
                "message": "",
                "hintMessage": ""
            }
        ],
        "operationType": null
    },
    {
        "fieldId": 186,
        "label": "Mini Truck Wheeler Types",
        "name": "Mini Truck Wheeler Types",
        "inputType": "image",
        "options": "3 wheeler,4 Wheeler,6 Wheeler",
        "collections": null,
        "type": "",
        "width": "",
        "value": null,
        "position": "",
        "customfield1": "1",
        "customfield2": "[{\"value\":\"3 wheeler\",\"image\":\"3Wheeler.png\"},{\"value\":\"4 Wheeler\",\"image\":\"4wheeler.png\"},{\"value\":\"6 Wheeler\",\"image\":\"6wheeler.png\"}]",
        "customfield3": "1,6wheeler.png",
        "customfield4": "",
        "customfield5": "",
        "validations": null,
        "typeId": 1,
        "conditionText": "Type of the truck =='mini truck'",
        "enableConditionalField": 1,
        "metaData": "{\"statement\":{\"groups\":[{\"conjunctor\":\"AND\",\"conditions\":[{\"filedName\":\"Type of the truck\",\"operators\":\"==\",\"fieldValue\":\"mini truck\"}],\"groups\":[]}]}}",
        "gaTrackingId": null,
        "dynamicFormLabelValidator": [
            {
                "entityId": 190,
                "parentId": 186,
                "name": "",
                "validator": "",
                "message": "",
                "hintMessage": ""
            }
        ],
        "operationType": null
    },
    {
        "fieldId": 187,
        "label": "Heavy Truck Wheeler Types",
        "name": "Heavy Truck Wheeler Types",
        "inputType": "image",
        "options": "10 Wheeler,12 Wheeler,14 Wheeler,16 Wheeler,18 Wheeler",
        "collections": null,
        "type": "",
        "width": "",
        "value": null,
        "position": "",
        "customfield1": "1",
        "customfield2": "[{\"value\":\"10 Wheeler\",\"image\":\"10wheeler.png\"},{\"value\":\"12 Wheeler\",\"image\":\"12wheeler.png\"},{\"value\":\"14 Wheeler\",\"image\":\"14wheeler.png\"},{\"value\":\"16 Wheeler\",\"image\":\"16wheeler.png\"},{\"value\":\"18 Wheeler\",\"image\":\"18Wheeler.png\"}]",
        "customfield3": "1,18Wheeler.png",
        "customfield4": "",
        "customfield5": "",
        "validations": null,
        "typeId": 1,
        "conditionText": "Type of the truck =='heavy truck'",
        "enableConditionalField": 1,
        "metaData": "{\"statement\":{\"groups\":[{\"conjunctor\":\"AND\",\"conditions\":[{\"filedName\":\"Type of the truck\",\"operators\":\"==\",\"fieldValue\":\"heavy truck\"}],\"groups\":[]}]}}",
        "gaTrackingId": null,
        "dynamicFormLabelValidator": [
            {
                "entityId": 191,
                "parentId": 187,
                "name": "",
                "validator": "",
                "message": "",
                "hintMessage": ""
            }
        ],
        "operationType": null
    },
    {
        "fieldId": 188,
        "label": "Brand Of The 4 Wheeler truck",
        "name": "Brand Of The 4 Wheeler truck",
        "inputType": "image",
        "options": "tata 4 wheeler mini truck,ashok leyland 4 wheeler mini truck,eicher 4 wheeler mini truck,mahindra 4 wheeler mini truck,maruti suzuki 4 wheeler mini truck,force 4 wheeler mini truck,other 4 wheeler mini truck",
        "collections": null,
        "type": "",
        "width": "",
        "value": null,
        "position": "",
        "customfield1": "1",
        "customfield2": "[{\"value\":\"tata 4 wheeler mini truck\",\"image\":\"TATAMotors.png\"},{\"value\":\"ashok leyland 4 wheeler mini truck\",\"image\":\"AshokLeyland.png\"},{\"value\":\"eicher 4 wheeler mini truck\",\"image\":\"Eicher.png\"},{\"value\":\"mahindra 4 wheeler mini truck\",\"image\":\"Mahindra.png\"},{\"value\":\"maruti suzuki 4 wheeler mini truck\",\"image\":\"MarutiSuzuki.png\"},{\"value\":\"force 4 wheeler mini truck\",\"image\":\"FORCE.png\"},{\"value\":\"other 4 wheeler mini truck\",\"image\":\"Otherbrand.png\"}]",
        "customfield3": "1,Otherbrand.png",
        "customfield4": "",
        "customfield5": "",
        "validations": null,
        "typeId": 1,
        "conditionText": "Mini Truck Wheeler Types =='4 wheeler'",
        "enableConditionalField": 1,
        "metaData": "{\"statement\":{\"groups\":[{\"conjunctor\":\"OR\",\"conditions\":[{\"filedName\":\"Mini Truck Wheeler Types\",\"operators\":\"==\",\"fieldValue\":\"4 wheeler\"}],\"groups\":[]}]}}",
        "gaTrackingId": null,
        "dynamicFormLabelValidator": [
            {
                "entityId": 192,
                "parentId": 188,
                "name": "",
                "validator": "",
                "message": "",
                "hintMessage": ""
            }
        ],
        "operationType": null
    },
    {
        "fieldId": 189,
        "label": "Brand Of The 6 Wheeler Truck",
        "name": "Brand Of The 6 Wheeler Truck",
        "inputType": "image",
        "options": "tata 6 Wheeler truck,ashok leyland 6 Wheeler truck,bharatbenz 6 Wheeler truck,eicher 6 Wheeler truck,smlisuzu 6 Wheeler truck,others 6 Wheeler truck",
        "collections": null,
        "type": "",
        "width": "",
        "value": null,
        "position": "",
        "customfield1": "1",
        "customfield2": "[{\"value\":\"tata 6 Wheeler truck\",\"image\":\"TATAMotors.png\"},{\"value\":\"ashok leyland 6 Wheeler truck\",\"image\":\"AshokLeyland.png\"},{\"value\":\"bharatbenz 6 Wheeler truck\",\"image\":\"Bharatbenz.png\"},{\"value\":\"eicher 6 Wheeler truck\",\"image\":\"Eicher.png\"},{\"value\":\"smlisuzu 6 Wheeler truck\",\"image\":\"SmlIsuzu.png\"},{\"value\":\"others 6 Wheeler truck\",\"image\":\"Otherbrand.png\"}]",
        "customfield3": "1,Otherbrand.png",
        "customfield4": "",
        "customfield5": "",
        "validations": null,
        "typeId": 1,
        "conditionText": "Mini Truck Wheeler Types =='6 wheeler'",
        "enableConditionalField": 1,
        "metaData": "{\"statement\":{\"groups\":[{\"conjunctor\":\"OR\",\"conditions\":[{\"filedName\":\"Mini Truck Wheeler Types\",\"operators\":\"==\",\"fieldValue\":\"6 wheeler\"}],\"groups\":[]}]}}",
        "gaTrackingId": null,
        "dynamicFormLabelValidator": [
            {
                "entityId": 193,
                "parentId": 189,
                "name": "",
                "validator": "",
                "message": "",
                "hintMessage": ""
            }
        ],
        "operationType": null
    },
    {
        "fieldId": 191,
        "label": "Tipper Wheeler Types",
        "name": "Tipper Wheeler Types",
        "inputType": "image",
        "options": "6 wheeler tipper,10 wheeler tipper,12 wheeler tipper,14 wheeler tipper,16 wheeler tipper,18 wheeler tipper",
        "collections": null,
        "type": "",
        "width": "",
        "value": null,
        "position": "",
        "customfield1": "1",
        "customfield2": "[{\"value\":\"6 wheeler tipper\",\"image\":\"6Wheeler.png\"},{\"value\":\"10 wheeler tipper\",\"image\":\"10Wheeler.png\"},{\"value\":\"12 wheeler tipper\",\"image\":\"12Wheeler.png\"},{\"value\":\"14 wheeler tipper\",\"image\":\"14Wheeler.png\"},{\"value\":\"16 wheeler tipper\",\"image\":\"16Wheeler.png\"},{\"value\":\"18 wheeler tipper\",\"image\":\"18Wheeler.png\"}]",
        "customfield3": "1,18Wheeler.png",
        "customfield4": "",
        "customfield5": "",
        "validations": null,
        "typeId": 1,
        "conditionText": "Type of the truck =='tipper'",
        "enableConditionalField": 1,
        "metaData": "{\"statement\":{\"groups\":[{\"conjunctor\":\"AND\",\"conditions\":[{\"filedName\":\"Type of the truck\",\"operators\":\"==\",\"fieldValue\":\"tipper\"}],\"groups\":[]}]}}",
        "gaTrackingId": null,
        "dynamicFormLabelValidator": [
            {
                "entityId": 195,
                "parentId": 191,
                "name": "",
                "validator": "",
                "message": "",
                "hintMessage": ""
            }
        ],
        "operationType": null
    },
    {
        "fieldId": 130,
        "label": "Select the brand of your bike",
        "name": "Select the brand of your bike",
        "inputType": "image",
        "options": "BMW Bike,Hero,Honda,Jawa,KTM,Royal Enfield,Suzuki,TVS,Yamaha,Bajaj",
        "collections": null,
        "type": "",
        "width": "",
        "value": null,
        "position": "",
        "customfield1": "1",
        "customfield2": "[{\"value\":\"BMW Bike\",\"image\":\"BMW.png\"},{\"value\":\"Hero\",\"image\":\"Hero.png\"},{\"value\":\"Honda\",\"image\":\"Honda.png\"},{\"value\":\"Jawa\",\"image\":\"Jawa.png\"},{\"value\":\"KTM\",\"image\":\"KTM.png\"},{\"value\":\"Royal Enfield\",\"image\":\"RoyalEnfield.png\"},{\"value\":\"Suzuki\",\"image\":\"Suzuki.png\"},{\"value\":\"TVS\",\"image\":\"TVS.png\"},{\"value\":\"Yamaha\",\"image\":\"Yamaha.png\"},{\"value\":\"Bajaj\",\"image\":\"Bajaj.png\"}]",
        "customfield3": "1,Bajaj.png",
        "customfield4": "",
        "customfield5": "",
        "validations": null,
        "typeId": 1,
        "conditionText": "Select Vehicle Type =='bike'",
        "enableConditionalField": 1,
        "metaData": "{\"statement\":{\"groups\":[{\"conjunctor\":\"OR\",\"conditions\":[{\"filedName\":\"Select Vehicle Type\",\"operators\":\"==\",\"fieldValue\":\"bike\"}],\"groups\":[]}]}}",
        "gaTrackingId": null,
        "dynamicFormLabelValidator": [
            {
                "entityId": 134,
                "parentId": 130,
                "name": "",
                "validator": "",
                "message": "",
                "hintMessage": ""
            }
        ],
        "operationType": null
    },
    {
        "fieldId": 193,
        "label": "Brand Of The 3 Wheeler Truck",
        "name": "Brand Of The 3 Wheeler Truck",
        "inputType": "image",
        "options": "tvs mini truck,bajaj mini truck,mahindra mini truck,atul mini truck,piaggio mini truck,others mini truck",
        "collections": null,
        "type": "",
        "width": "",
        "value": null,
        "position": "",
        "customfield1": "1",
        "customfield2": "[{\"value\":\"tvs mini truck\",\"image\":\"tvss.webp\"},{\"value\":\"bajaj mini truck\",\"image\":\"Bajaj.png\"},{\"value\":\"mahindra mini truck\",\"image\":\"Mahindra.png\"},{\"value\":\"atul mini truck\",\"image\":\"ATUL.png\"},{\"value\":\"piaggio mini truck\",\"image\":\"PIAGGIO.png\"},{\"value\":\"others mini truck\",\"image\":\"Otherbrand.png\"}]",
        "customfield3": "1,Otherbrand.png",
        "customfield4": "",
        "customfield5": "",
        "validations": null,
        "typeId": 1,
        "conditionText": "Mini Truck Wheeler Types =='3 wheeler'",
        "enableConditionalField": 1,
        "metaData": "{\"statement\":{\"groups\":[{\"conjunctor\":\"OR\",\"conditions\":[{\"filedName\":\"Mini Truck Wheeler Types\",\"operators\":\"==\",\"fieldValue\":\"3 wheeler\"}],\"groups\":[]}]}}",
        "gaTrackingId": null,
        "dynamicFormLabelValidator": [
            {
                "entityId": 197,
                "parentId": 193,
                "name": "",
                "validator": "",
                "message": "",
                "hintMessage": ""
            }
        ],
        "operationType": null
    },
    {
        "fieldId": 154,
        "label": "Model of the Bajaj Bike",
        "name": "Model of the Bajaj Bike",
        "inputType": "image",
        "options": "Pulsar RS200,Pulsar 200,Pulsar AS200,Pulsar NS200,Discover125,Platina 110,Bajaj ct125,discover 100,discover 150,platina 100 cc,platina 125 cc",
        "collections": null,
        "type": "",
        "width": "",
        "value": null,
        "position": "",
        "customfield1": "1",
        "customfield2": "[{\"value\":\"Pulsar RS200\",\"image\":\"pulsarrs200.png\"},{\"value\":\"Pulsar 200\",\"image\":\"pulsar200.png\"},{\"value\":\"Pulsar AS200\",\"image\":\"pulsaras200.png\"},{\"value\":\"Pulsar NS200\",\"image\":\"pulsarns200.png\"},{\"value\":\"Discover125\",\"image\":\"discover125.png\"},{\"value\":\"Platina 110\",\"image\":\"platina110.png\"},{\"value\":\"Bajaj ct125\",\"image\":\"CT125.png\"},{\"value\":\"discover 100\",\"image\":\"Discover100.png\"},{\"value\":\"discover 150\",\"image\":\"Discover150.png\"},{\"value\":\"platina 100 cc\",\"image\":\"Platina100.png\"},{\"value\":\"platina 125 cc\",\"image\":\"Platina125.png\"}]",
        "customfield3": "1,Platina125.png",
        "customfield4": "",
        "customfield5": "",
        "validations": null,
        "typeId": 1,
        "conditionText": "Select the brand of your bike =='Bajaj'",
        "enableConditionalField": 1,
        "metaData": "{\"statement\":{\"groups\":[{\"conjunctor\":\"OR\",\"conditions\":[{\"filedName\":\"Select the brand of your bike\",\"operators\":\"==\",\"fieldValue\":\"Bajaj\"}],\"groups\":[]}]}}",
        "gaTrackingId": null,
        "dynamicFormLabelValidator": [
            {
                "entityId": 158,
                "parentId": 154,
                "name": "",
                "validator": "",
                "message": "",
                "hintMessage": ""
            }
        ],
        "operationType": null
    },
    {
        "fieldId": 153,
        "label": "Model of the Yamaha Bike",
        "name": "Model of the Yamaha Bike",
        "inputType": "image",
        "options": "MT-15,Ray ZR,RX100,Fascino 125 Fi Disc,FZ-25,FZ25,yamaha crux,yamaha rx135 5speed,yamaha rx135",
        "collections": null,
        "type": "",
        "width": "",
        "value": null,
        "position": "",
        "customfield1": "1",
        "customfield2": "[{\"value\":\"MT-15\",\"image\":\"mt15.png\"},{\"value\":\"Ray ZR\",\"image\":\"rayzr.png\"},{\"value\":\"RX100\",\"image\":\"rx100.png\"},{\"value\":\"Fascino 125 Fi Disc\",\"image\":\"fascino125fidisc.png\"},{\"value\":\"FZ-25\",\"image\":\"fz25.png\"},{\"value\":\"FZ25\",\"image\":\"fz25.png\"},{\"value\":\"yamaha crux\",\"image\":\"CRUX.png\"},{\"value\":\"yamaha rx135 5speed\",\"image\":\"RX1355Speed.png\"},{\"value\":\"yamaha rx135\",\"image\":\"RX135.png\"}]",
        "customfield3": "1,RX135.png",
        "customfield4": "",
        "customfield5": "",
        "validations": null,
        "typeId": 1,
        "conditionText": "Select the brand of your bike =='Yamaha'",
        "enableConditionalField": 1,
        "metaData": "{\"statement\":{\"groups\":[{\"conjunctor\":\"OR\",\"conditions\":[{\"filedName\":\"Select the brand of your bike\",\"operators\":\"==\",\"fieldValue\":\"Yamaha\"}],\"groups\":[]}]}}",
        "gaTrackingId": null,
        "dynamicFormLabelValidator": [
            {
                "entityId": 157,
                "parentId": 153,
                "name": "",
                "validator": "",
                "message": "",
                "hintMessage": ""
            }
        ],
        "operationType": null
    },
    {
        "fieldId": 152,
        "label": "Model of the TVS Bike",
        "name": "Model of the TVS Bike",
        "inputType": "image",
        "options": "XL 100,XL Super,Star Deluxe,Victor,XL 100 Comfort,Jupiter,Streak,Apache RTR 200 Fi E100,Others",
        "collections": null,
        "type": "",
        "width": "",
        "value": null,
        "position": "",
        "customfield1": "1",
        "customfield2": "[{\"value\":\"XL 100\",\"image\":\"xl100.png\"},{\"value\":\"XL Super\",\"image\":\"xlsuper.png\"},{\"value\":\"Star Deluxe\",\"image\":\"tvsstardeluxe.png\"},{\"value\":\"Victor\",\"image\":\"victor.png\"},{\"value\":\"XL 100 Comfort\",\"image\":\"xl100Comport.png\"},{\"value\":\"Jupiter\",\"image\":\"jupiter.png\"},{\"value\":\"Streak\",\"image\":\"streak.png\"},{\"value\":\"Apache RTR 200 Fi E100\",\"image\":\"apachertr200fie100.png\"},{\"value\":\"Others\",\"image\":\"Others.png\"}]",
        "customfield3": "1,Others.png",
        "customfield4": "",
        "customfield5": "",
        "validations": null,
        "typeId": 1,
        "conditionText": "Select the brand of your bike =='TVS'",
        "enableConditionalField": 1,
        "metaData": "{\"statement\":{\"groups\":[{\"conjunctor\":\"OR\",\"conditions\":[{\"filedName\":\"Select the brand of your bike\",\"operators\":\"==\",\"fieldValue\":\"TVS\"}],\"groups\":[]}]}}",
        "gaTrackingId": null,
        "dynamicFormLabelValidator": [
            {
                "entityId": 156,
                "parentId": 152,
                "name": "",
                "validator": "",
                "message": "",
                "hintMessage": ""
            }
        ],
        "operationType": null
    },
    {
        "fieldId": 151,
        "label": "Model of the Suzuki Bike",
        "name": "Model of the Suzuki Bike",
        "inputType": "image",
        "options": "Gixxer SF 250,GSX S750,Access 125 SE,Others",
        "collections": null,
        "type": "",
        "width": "",
        "value": null,
        "position": "",
        "customfield1": "1",
        "customfield2": "[{\"value\":\"Gixxer SF 250\",\"image\":\"GixxerSF250.png\"},{\"value\":\"GSX S750\",\"image\":\"GSXS750.png\"},{\"value\":\"Access 125 SE\",\"image\":\"Access125SE.png\"},{\"value\":\"Others\",\"image\":\"Others.png\"}]",
        "customfield3": "1,Others.png",
        "customfield4": "",
        "customfield5": "",
        "validations": null,
        "typeId": 1,
        "conditionText": "Select the brand of your bike =='Suzuki'",
        "enableConditionalField": 1,
        "metaData": "{\"statement\":{\"groups\":[{\"conjunctor\":\"OR\",\"conditions\":[{\"filedName\":\"Select the brand of your bike\",\"operators\":\"==\",\"fieldValue\":\"Suzuki\"}],\"groups\":[]}]}}",
        "gaTrackingId": null,
        "dynamicFormLabelValidator": [
            {
                "entityId": 155,
                "parentId": 151,
                "name": "",
                "validator": "",
                "message": "",
                "hintMessage": ""
            }
        ],
        "operationType": null
    },
    {
        "fieldId": 150,
        "label": "Model of the Royal Enfield Bike",
        "name": "Model of the Royal Enfield Bike",
        "inputType": "image",
        "options": "Interceptor 650,Thunderbird 500,Hunter 350,Himalayan,Bullet 500,Others",
        "collections": null,
        "type": "",
        "width": "",
        "value": null,
        "position": "",
        "customfield1": "1",
        "customfield2": "[{\"value\":\"Interceptor 650\",\"image\":\"Interceptor650.png\"},{\"value\":\"Thunderbird 500\",\"image\":\"Thunderbird500.png\"},{\"value\":\"Hunter 350\",\"image\":\"Hunter350.png\"},{\"value\":\"Himalayan\",\"image\":\"Himalayan.png\"},{\"value\":\"Bullet 500\",\"image\":\"Bullet500.png\"},{\"value\":\"Others\",\"image\":\"Others.png\"}]",
        "customfield3": "1,Others.png",
        "customfield4": "",
        "customfield5": "",
        "validations": null,
        "typeId": 1,
        "conditionText": "Select the brand of your bike =='Royal'",
        "enableConditionalField": 1,
        "metaData": "{\"statement\":{\"groups\":[{\"conjunctor\":\"OR\",\"conditions\":[{\"filedName\":\"Select the brand of your bike\",\"operators\":\"==\",\"fieldValue\":\"Royal\"}],\"groups\":[]}]}}",
        "gaTrackingId": null,
        "dynamicFormLabelValidator": [
            {
                "entityId": 154,
                "parentId": 150,
                "name": "",
                "validator": "",
                "message": "",
                "hintMessage": ""
            }
        ],
        "operationType": null
    },
    {
        "fieldId": 149,
        "label": "Model of the KTM Bike",
        "name": "Model of the KTM Bike",
        "inputType": "image",
        "options": "RC390,790 Duke,790 Duke,RC200,390 Duke,690 Duke,Others",
        "collections": null,
        "type": "",
        "width": "",
        "value": null,
        "position": "",
        "customfield1": "1",
        "customfield2": "[{\"value\":\"RC390\",\"image\":\"RC390.png\"},{\"value\":\"790 Duke\",\"image\":\"790Duke.png\"},{\"value\":\"790 Duke\",\"image\":\"RC2002020.png\"},{\"value\":\"RC200\",\"image\":\"RC200.png\"},{\"value\":\"390 Duke\",\"image\":\"390Duke.png\"},{\"value\":\"690 Duke\",\"image\":\"690Duke.png\"},{\"value\":\"Others\",\"image\":\"Others.png\"}]",
        "customfield3": "1,Others.png",
        "customfield4": "",
        "customfield5": "",
        "validations": null,
        "typeId": 1,
        "conditionText": "Select the brand of your bike =='KTM'",
        "enableConditionalField": 1,
        "metaData": "{\"statement\":{\"groups\":[{\"conjunctor\":\"OR\",\"conditions\":[{\"filedName\":\"Select the brand of your bike\",\"operators\":\"==\",\"fieldValue\":\"KTM\"}],\"groups\":[]}]}}",
        "gaTrackingId": null,
        "dynamicFormLabelValidator": [
            {
                "entityId": 153,
                "parentId": 149,
                "name": "",
                "validator": "",
                "message": "",
                "hintMessage": ""
            }
        ],
        "operationType": null
    },
    {
        "fieldId": 148,
        "label": "Model of the Jawa Bike",
        "name": "Model of the Jawa Bike",
        "inputType": "image",
        "options": "Forty-two,Perak,Standard,Others",
        "collections": null,
        "type": "",
        "width": "",
        "value": null,
        "position": "",
        "customfield1": "1",
        "customfield2": "[{\"value\":\"Forty-two\",\"image\":\"Fortytwo.png\"},{\"value\":\"Perak\",\"image\":\"Perak.png\"},{\"value\":\"Standard\",\"image\":\"Standard.png\"},{\"value\":\"Others\",\"image\":\"Others.png\"}]",
        "customfield3": "1,Others.png",
        "customfield4": "",
        "customfield5": "",
        "validations": null,
        "typeId": 1,
        "conditionText": "Select the brand of your bike =='Jawa'",
        "enableConditionalField": 1,
        "metaData": "{\"statement\":{\"groups\":[{\"conjunctor\":\"OR\",\"conditions\":[{\"filedName\":\"Select the brand of your bike\",\"operators\":\"==\",\"fieldValue\":\"Jawa\"}],\"groups\":[]}]}}",
        "gaTrackingId": null,
        "dynamicFormLabelValidator": [
            {
                "entityId": 152,
                "parentId": 148,
                "name": "",
                "validator": "",
                "message": "",
                "hintMessage": ""
            }
        ],
        "operationType": null
    },
    {
        "fieldId": 147,
        "label": "Model of the Honda Bike",
        "name": "Model of the Honda Bike",
        "inputType": "image",
        "options": "Dio,Shine 100cc,Unicorn,Activa 6G,Activa i,Africa Twin,Activa 4G,Activa 5G",
        "collections": null,
        "type": "",
        "width": "",
        "value": null,
        "position": "",
        "customfield1": "1",
        "customfield2": "[{\"value\":\"Dio\",\"image\":\"Dio.png\"},{\"value\":\"Shine 100cc\",\"image\":\"Shine100cc.png\"},{\"value\":\"Unicorn\",\"image\":\"Unicorn.png\"},{\"value\":\"Activa 6G\",\"image\":\"Activa6G.png\"},{\"value\":\"Activa i\",\"image\":\"Activai.png\"},{\"value\":\"Africa Twin\",\"image\":\"AfricaTwin.png\"},{\"value\":\"Activa 4G\",\"image\":\"Activa4G.png\"},{\"value\":\"Activa 5G\",\"image\":\"Activa5G.png\"}]",
        "customfield3": "1,Activa5G.png",
        "customfield4": "",
        "customfield5": "",
        "validations": null,
        "typeId": 1,
        "conditionText": "Select the brand of your bike =='Honda'",
        "enableConditionalField": 1,
        "metaData": "{\"statement\":{\"groups\":[{\"conjunctor\":\"AND\",\"conditions\":[{\"filedName\":\"Select the brand of your bike\",\"operators\":\"==\",\"fieldValue\":\"Honda\"}],\"groups\":[]}]}}",
        "gaTrackingId": null,
        "dynamicFormLabelValidator": [
            {
                "entityId": 151,
                "parentId": 147,
                "name": "",
                "validator": "",
                "message": "",
                "hintMessage": ""
            }
        ],
        "operationType": null
    },
    {
        "fieldId": 146,
        "label": "Model of the Hero Bike",
        "name": "Model of the Hero Bike",
        "inputType": "image",
        "options": "Splendor Plus i3s,Splendor+,Glamour,New Glamour,New Super Splender,Others",
        "collections": null,
        "type": "",
        "width": "",
        "value": null,
        "position": "",
        "customfield1": "1",
        "customfield2": "[{\"value\":\"Splendor Plus i3s\",\"image\":\"SplendorPlusi3s.png\"},{\"value\":\"Splendor+\",\"image\":\"Splendor.png\"},{\"value\":\"Glamour\",\"image\":\"Glamour.png\"},{\"value\":\"New Glamour\",\"image\":\"NewGlamour.png\"},{\"value\":\"New Super Splender\",\"image\":\"NewSuperSplendor.png\"},{\"value\":\"Others\",\"image\":\"Others.png\"}]",
        "customfield3": "1,Others.png",
        "customfield4": "",
        "customfield5": "",
        "validations": null,
        "typeId": 1,
        "conditionText": "Select the brand of your bike =='Hero'",
        "enableConditionalField": 1,
        "metaData": "{\"statement\":{\"groups\":[{\"conjunctor\":\"OR\",\"conditions\":[{\"filedName\":\"Select the brand of your bike\",\"operators\":\"==\",\"fieldValue\":\"Hero\"}],\"groups\":[]}]}}",
        "gaTrackingId": null,
        "dynamicFormLabelValidator": [
            {
                "entityId": 150,
                "parentId": 146,
                "name": "",
                "validator": "",
                "message": "",
                "hintMessage": ""
            }
        ],
        "operationType": null
    },
    {
        "fieldId": 132,
        "label": "Model of the audi car",
        "name": "Model of the audi car",
        "inputType": "image",
        "options": "A4,A6,Q2,Q3,Q7,others",
        "collections": null,
        "type": "",
        "width": "",
        "value": null,
        "position": "",
        "customfield1": "1",
        "customfield2": "[{\"value\":\"A4\",\"image\":\"A4.png\"},{\"value\":\"A6\",\"image\":\"A6.png\"},{\"value\":\"Q2\",\"image\":\"Q2.png\"},{\"value\":\"Q3\",\"image\":\"Q3.png\"},{\"value\":\"Q7\",\"image\":\"Q7.png\"},{\"value\":\"others\",\"image\":\"Others.png\"}]",
        "customfield3": "1,Others.png",
        "customfield4": "",
        "customfield5": "",
        "validations": null,
        "typeId": 1,
        "conditionText": "Brand Of The Car =='AUDI'",
        "enableConditionalField": 1,
        "metaData": "{\"statement\":{\"groups\":[{\"conjunctor\":\"OR\",\"conditions\":[{\"filedName\":\"Brand Of The Car\",\"operators\":\"==\",\"fieldValue\":\"AUDI\"}],\"groups\":[]}]}}",
        "gaTrackingId": null,
        "dynamicFormLabelValidator": [
            {
                "entityId": 136,
                "parentId": 132,
                "name": "",
                "validator": "",
                "message": "",
                "hintMessage": ""
            }
        ],
        "operationType": null
    },
    {
        "fieldId": 145,
        "label": "Model of the BMW Bike",
        "name": "Model of the BMW Bike",
        "inputType": "image",
        "options": "S 1000 XR,R Nine T Scrambler,S 1000 R,G310R,R 1200 R,Others",
        "collections": null,
        "type": "",
        "width": "",
        "value": null,
        "position": "",
        "customfield1": "1",
        "customfield2": "[{\"value\":\"S 1000 XR\",\"image\":\"S1000XR.png\"},{\"value\":\"R Nine T Scrambler\",\"image\":\"RNineTScrambler.png\"},{\"value\":\"S 1000 R\",\"image\":\"S1000R.png\"},{\"value\":\"G310R\",\"image\":\"G310R.png\"},{\"value\":\"R 1200 R\",\"image\":\"R1200R.png\"},{\"value\":\"Others\",\"image\":\"Others.png\"}]",
        "customfield3": "1,Others.png",
        "customfield4": "",
        "customfield5": "",
        "validations": null,
        "typeId": 1,
        "conditionText": "Select the brand of your bike =='BMW Bike'",
        "enableConditionalField": 1,
        "metaData": "{\"statement\":{\"groups\":[{\"conjunctor\":\"OR\",\"conditions\":[{\"filedName\":\"Select the brand of your bike\",\"operators\":\"==\",\"fieldValue\":\"BMW Bike\"}],\"groups\":[]}]}}",
        "gaTrackingId": null,
        "dynamicFormLabelValidator": [
            {
                "entityId": 149,
                "parentId": 145,
                "name": "",
                "validator": "",
                "message": "",
                "hintMessage": ""
            }
        ],
        "operationType": null
    },
    {
        "fieldId": 133,
        "label": "Model of the benz car",
        "name": "Model of the benz car",
        "inputType": "image",
        "options": "A-Class,C-Class,E-Class,GLA,GLC,GLE,GLS,GLB,others",
        "collections": null,
        "type": "",
        "width": "",
        "value": null,
        "position": "",
        "customfield1": "1",
        "customfield2": "[{\"value\":\"A-Class\",\"image\":\"AClass.png\"},{\"value\":\"C-Class\",\"image\":\"CClass.png\"},{\"value\":\"E-Class\",\"image\":\"EClass.png\"},{\"value\":\"GLA\",\"image\":\"GLA.png\"},{\"value\":\"GLC\",\"image\":\"GLC.png\"},{\"value\":\"GLE\",\"image\":\"GLE.png\"},{\"value\":\"GLS\",\"image\":\"GLS.png\"},{\"value\":\"GLB\",\"image\":\"GLB.png\"},{\"value\":\"others\",\"image\":\"Others.png\"}]",
        "customfield3": "1,Others.png",
        "customfield4": "",
        "customfield5": "",
        "validations": null,
        "typeId": 1,
        "conditionText": "Brand Of The Car =='BENZ'",
        "enableConditionalField": 1,
        "metaData": "{\"statement\":{\"groups\":[{\"conjunctor\":\"OR\",\"conditions\":[{\"filedName\":\"Brand Of The Car\",\"operators\":\"==\",\"fieldValue\":\"BENZ\"}],\"groups\":[]}]}}",
        "gaTrackingId": null,
        "dynamicFormLabelValidator": [
            {
                "entityId": 137,
                "parentId": 133,
                "name": "",
                "validator": "",
                "message": "",
                "hintMessage": ""
            }
        ],
        "operationType": null
    },
    {
        "fieldId": 134,
        "label": "Model of the bmw car",
        "name": "Model of the bmw car",
        "inputType": "image",
        "options": "6 Series,7 Series,8 Series,X1,X3,X4,X5,1 Series,3 Series,5 Series,other",
        "collections": null,
        "type": "",
        "width": "",
        "value": null,
        "position": "",
        "customfield1": "1",
        "customfield2": "[{\"value\":\"6 Series\",\"image\":\"6Series.png\"},{\"value\":\"7 Series\",\"image\":\"7Series.png\"},{\"value\":\"8 Series\",\"image\":\"8Series.png\"},{\"value\":\"X1\",\"image\":\"X1.png\"},{\"value\":\"X3\",\"image\":\"X3.png\"},{\"value\":\"X4\",\"image\":\"X4.png\"},{\"value\":\"X5\",\"image\":\"X5.png\"},{\"value\":\"1 Series\",\"image\":\"1Series.png\"},{\"value\":\"3 Series\",\"image\":\"3Series.png\"},{\"value\":\"5 Series\",\"image\":\"5Series.png\"},{\"value\":\"other\",\"image\":\"Others.png\"}]",
        "customfield3": "1,Others.png",
        "customfield4": "",
        "customfield5": "",
        "validations": null,
        "typeId": 1,
        "conditionText": "Brand Of The Car =='BMW'",
        "enableConditionalField": 1,
        "metaData": "{\"statement\":{\"groups\":[{\"conjunctor\":\"AND\",\"conditions\":[{\"filedName\":\"Brand Of The Car\",\"operators\":\"==\",\"fieldValue\":\"BMW\"}],\"groups\":[]}]}}",
        "gaTrackingId": null,
        "dynamicFormLabelValidator": [
            {
                "entityId": 138,
                "parentId": 134,
                "name": "",
                "validator": "",
                "message": "",
                "hintMessage": ""
            }
        ],
        "operationType": null
    },
    {
        "fieldId": 135,
        "label": "Model of the ford car",
        "name": "Model of the ford car",
        "inputType": "image",
        "options": "EcoSport,Figo Aspire,Figo,Freestyle,others",
        "collections": null,
        "type": "",
        "width": "",
        "value": null,
        "position": "",
        "customfield1": "1",
        "customfield2": "[{\"value\":\"EcoSport\",\"image\":\"EcoSport.png\"},{\"value\":\"Figo Aspire\",\"image\":\"FigoAspire.png\"},{\"value\":\"Figo\",\"image\":\"Figo.png\"},{\"value\":\"Freestyle\",\"image\":\"Freestyle.png\"},{\"value\":\"others\",\"image\":\"Others.png\"}]",
        "customfield3": "1,Others.png",
        "customfield4": "",
        "customfield5": "",
        "validations": null,
        "typeId": 1,
        "conditionText": "Brand Of The Car =='Ford'",
        "enableConditionalField": 1,
        "metaData": "{\"statement\":{\"groups\":[{\"conjunctor\":\"OR\",\"conditions\":[{\"filedName\":\"Brand Of The Car\",\"operators\":\"==\",\"fieldValue\":\"Ford\"}],\"groups\":[]}]}}",
        "gaTrackingId": null,
        "dynamicFormLabelValidator": [
            {
                "entityId": 139,
                "parentId": 135,
                "name": "",
                "validator": "",
                "message": "",
                "hintMessage": ""
            }
        ],
        "operationType": null
    },
    {
        "fieldId": 136,
        "label": "Model of the kia car",
        "name": "Model of the kia car",
        "inputType": "image",
        "options": "Carens,Carnival,Seltos,Sonet,others",
        "collections": null,
        "type": "",
        "width": "",
        "value": null,
        "position": "",
        "customfield1": "1",
        "customfield2": "[{\"value\":\"Carens\",\"image\":\"Carens.png\"},{\"value\":\"Carnival\",\"image\":\"Carnival.png\"},{\"value\":\"Seltos\",\"image\":\"Seltos.png\"},{\"value\":\"Sonet\",\"image\":\"Sonet.png\"},{\"value\":\"others\",\"image\":\"Others.png\"}]",
        "customfield3": "1,Others.png",
        "customfield4": "",
        "customfield5": "",
        "validations": null,
        "typeId": 1,
        "conditionText": "Brand Of The Car =='KIA'",
        "enableConditionalField": 1,
        "metaData": "{\"statement\":{\"groups\":[{\"conjunctor\":\"AND\",\"conditions\":[{\"filedName\":\"Brand Of The Car\",\"operators\":\"==\",\"fieldValue\":\"KIA\"}],\"groups\":[]}]}}",
        "gaTrackingId": null,
        "dynamicFormLabelValidator": [
            {
                "entityId": 140,
                "parentId": 136,
                "name": "",
                "validator": "",
                "message": "",
                "hintMessage": ""
            }
        ],
        "operationType": null
    },
    {
        "fieldId": 137,
        "label": "Model of the mahindra car",
        "name": "Model of the mahindra car",
        "inputType": "image",
        "options": "Scorpio N,Thar,XUV 300 TurboSport,XUV 300,XUV700,Bolero Neo,Bolero,KUV100,KUV100 NXT,Marazzo,Scorpio Classic,Others",
        "collections": null,
        "type": "",
        "width": "",
        "value": null,
        "position": "",
        "customfield1": "1",
        "customfield2": "[{\"value\":\"Scorpio N\",\"image\":\"ScorpioN.png\"},{\"value\":\"Thar\",\"image\":\"Thar.png\"},{\"value\":\"XUV 300 TurboSport\",\"image\":\"XUV300TurboSport.png\"},{\"value\":\"XUV 300\",\"image\":\"XUV300.png\"},{\"value\":\"XUV700\",\"image\":\"XUV700.png\"},{\"value\":\"Bolero Neo\",\"image\":\"BoleroNeo.png\"},{\"value\":\"Bolero\",\"image\":\"Bolero.png\"},{\"value\":\"KUV100\",\"image\":\"KUV100.png\"},{\"value\":\"KUV100 NXT\",\"image\":\"KUV100NXT.png\"},{\"value\":\"Marazzo\",\"image\":\"Marazzo.png\"},{\"value\":\"Scorpio Classic\",\"image\":\"ScorpioClasisc.png\"},{\"value\":\"Others\",\"image\":\"Others.png\"}]",
        "customfield3": "1,Others.png",
        "customfield4": "",
        "customfield5": "",
        "validations": null,
        "typeId": 1,
        "conditionText": "Brand Of The Car =='Mahindra'",
        "enableConditionalField": 1,
        "metaData": "{\"statement\":{\"groups\":[{\"conjunctor\":\"OR\",\"conditions\":[{\"filedName\":\"Brand Of The Car\",\"operators\":\"==\",\"fieldValue\":\"Mahindra\"}],\"groups\":[]}]}}",
        "gaTrackingId": null,
        "dynamicFormLabelValidator": [
            {
                "entityId": 141,
                "parentId": 137,
                "name": "",
                "validator": "",
                "message": "",
                "hintMessage": ""
            }
        ],
        "operationType": null
    }
]

  ngOnInit() {


    if (this.customField13 == 1) {


      this.initSecondForm = true;
    }
    
  // this.fields=this.value1;
    this.form = this.createControl();
    this.subscribeToFormChanges();

    this.valuesInputed.push(this.fields[0].name)
    this.formInit = true;
    this.previousFormField = this.fields[0].name;
    this.objectTobeDisplayed = this.fields[0];
    this.formInit1 = true;
    this.indexNew = 0;

    this.EnablePayment = this.customField5;
  }

  onSubmit() {
    if (this.form.valid) {
      this.submit.emit(this.form.value);
    } else {
      this.validateAllFormFields(this.form);
    }
  }

  createControl() {
    const group = this.fb.group({});
    this.fields.forEach(field => {
      if (field.type === "button") return;
      const control = this.fb.control(
        field.value,
        this.bindValidations(field['dynamicFormLabelValidator'] || [])
      );
      group.addControl(field.name, control);
    });
    return group;
  }

  subscribeToFormChanges() {
    this.form.valueChanges.subscribe(changes => {
      const changedField = Object.keys(changes).find(key => this.form.get(key)?.dirty);

      if (changedField) {
        const fieldConfig = this.fields.find(field => field.name === changedField);
        const fieldInputType = fieldConfig ? fieldConfig.inputType : null;

        if (!this.excludedInputTypes.has(fieldInputType)&&this.customField13==1 ) {
          this.subscriptionService.updateFormValue(this.form);
          this.updateConditionalFieldsVisibility();
        }else if(this.customField13==0){
          this.subscriptionService.updateFormValue(this.form);
          this.updateConditionalFieldsVisibility();
        }
      }
    });
  }
  updateConditionalFieldsVisibility() {
    this.fields.forEach(field => {
      if (field.enableConditionalField == 1) {
        const conditionResult = this.evaluateCondition(field.conditionText, this.form.value);
  
        if (conditionResult) {
          let index = this.valuesInputed.findIndex(x => x == field.name);
  
          if (index < 0) {
            this.objectTobeDisplayed = field;
            this.formInit1 = true;
            this.valuesInputed.push(this.objectTobeDisplayed.name);
            this.indexInital = this.indexInital + 1;
          }
  
          if (this.valuesInputed.length > 1) {
            this.dontDisplayBackButton = true;
          }
        }
  
        field.visible = conditionResult;
      }
    });
  }
  
  evaluateCondition(conditionText: string, formValues: any): boolean {
    if (!conditionText) return true; // If no condition specified, return true
    return this.evaluateExpression(conditionText, formValues);
  }
  
  evaluateExpression(expression: string, formValues: any): boolean {
    if (!expression) return true;
  
    expression = expression.replace(/\s+or\s+/g, ' || ').replace(/\s+and\s+/g, ' && ');
  
    const blocks = expression.split(/\s*\|\|\s*/);
  
    for (const block of blocks) {
      // Split block by AND (&&) operator
      const conditions = block.split(/\s*&&\s*/);
      let allConditionsTrue = true;
  
      for (const condition of conditions) {
        const conditionResult = this.evaluateSingleCondition(condition.trim(), formValues);
        if (!conditionResult) {
          allConditionsTrue = false;
          break;
        }
      }
  
      if (allConditionsTrue) {
        return true; // If all conditions in a block are true, the OR block is true
      }
    }
  
    return false; // If none of the OR blocks are true
  }
  
  evaluateSingleCondition(condition: string, formValues: any): boolean {
    let [variable, operator, value] = condition.split(/\s*(===|!==|==|!=|<|>|<=|>=)\s*/);
  
    if (variable.includes('.length')) {
      const varWithoutLength = variable.replace('.length', '').trim();
      const variableValue = (formValues[varWithoutLength] as string)?.length ?? 0;

      const lengthValue = parseInt(value.replace(/'/g, ""), 10);
  
      switch (operator) {
        case '===':
        case '==':
          return variableValue === lengthValue;
        case '!==':
        case '!=':
          return variableValue !== lengthValue;
        case '<':
          return variableValue < lengthValue;
        case '>':
          return variableValue > lengthValue;
        case '<=':
          return variableValue <= lengthValue;
        case '>=':
          return variableValue >= lengthValue;
        default:
          return false;
      }
    } else {
      const variableValue = formValues[variable.trim()];
      const cleanValue = value.replace(/'/g, '');
      const variableValueNumber = parseFloat(variableValue);
  
      switch (operator) {
        case '===':
          return variableValue === cleanValue;
        case '!==':
          return variableValue !== cleanValue;
        case '==':
          return variableValue == cleanValue || variableValueNumber == parseFloat(cleanValue);
        case '!=':
          return variableValue != cleanValue && variableValueNumber != parseFloat(cleanValue);
        case '<':
          return variableValueNumber < parseFloat(cleanValue);
        case '>':
          return variableValueNumber > parseFloat(cleanValue);
        case '<=':
          return variableValueNumber <= parseFloat(cleanValue);
        case '>=':
          return variableValueNumber >= parseFloat(cleanValue);
        default:
          return false;
      }
    }
  }

  bindValidations(validations: any) {
    if (validations.length > 0) {
      const validList = [];
      let minLength: number | null = null;
      let maxLength: number | null = null;
  
      validations.forEach(valid => {
        if (valid.name === 'required') {
          validList.push(Validators.required);
        } else if (valid.name === 'pattern') {
          validList.push(Validators.pattern(valid.validator));
        } else if (valid.name === 'minLength') {
          if (valid.minLength) {
            minLength = parseInt(valid.minLength);
          }
        } else if (valid.name === 'maxLength') {
          if (valid.maxlength) {
            maxLength = parseInt(valid.maxlength);
          }
        }
      });
  

      if (minLength !== null) {
        validList.push(Validators.minLength(minLength));
      }
      if (maxLength !== null) {
        validList.push(Validators.maxLength(maxLength));
      }
  
      return Validators.compose(validList);
    }
    return null;
  }
  
  validateAllFormFields(formGroup: UntypedFormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      control.markAsTouched({ onlySelf: true });
    });
  }

  calculateFlexValue(layout: number, gapBetweenImage: boolean): string {
    const baseFlex = layout === 2 ? '50%' :
      layout === 3 ? '33.33%' :
        layout === 4 ? '25%' : '100%';
    return gapBetweenImage ? `calc(${baseFlex} - ${gapBetweenImage})` : baseFlex;
  }

  indexInital: any = 0;

 
  onFieldValueChange(value: any) {

    this.previousFormField = value;
 
    
    this.previousFormFieldsList.push(value);

    this.subscribeToFormChangesText()


  }

  onFieldValueChange1(value: any) {

    if(value == true){
      this.formInitSecond = true;
    }


  }
  Gotonextform(){
    this.formInitSecond=true
  }


  onFieldValueChangeImage(value: any) {
    this.imageList = value;
    this.onFieldValueChange(value);

    this.formInitSecond = true;

  }

  SubmitForm(object) {

    if (object.operationType = "New") {
      this.productListiingService.submitProductListing(object).subscribe(
        (response) => {
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 3000 });
            this.router.navigate(['/home']);
            
          }
          else {
            this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
          }
        },
        (err) => { this.text = "Submit" });
    }
    else {

    }



  }

  getIndex() {

    this.indexInital = this.indexInital;



  }

  back() {

    let length = 0;


    let newLength = this.valuesInputed.length - 1;


    let indexNew = this.fields.findIndex(x => x['name'] == this.valuesInputed[newLength]);

    if (indexNew > -1) {

      if (this.form.value[this.fields[indexNew].name] != '' && this.form.value[this.fields[indexNew].name] != null) {
        this.form.get(this.fields[indexNew].name).setValue('');
      }

    }
  indexNew = this.fields.findIndex(x => x['name'] == this.valuesInputed[newLength-1]);

    if (indexNew > -1) {

      if (this.form.value[this.fields[indexNew].name] != '' && this.form.value[this.fields[indexNew].name] != null) {
        this.form.get(this.fields[indexNew].name).setValue('');
      }

    }



    if (this.valuesInputed.length == 1) {
      this.dontDisplayBackButton = false;
      length = 0;
    } else {

      this.valuesInputed = this.valuesInputed.slice(0, -1);
      length = this.valuesInputed.length - 1;

    }


    if (length == 0) {
      this.dontDisplayBackButton = false;
    }

    let index = this.fields.findIndex(x => x['name'] == this.valuesInputed[length]);

    if (index > -1) {

      this.objectTobeDisplayed = this.fields[index];
    }


  }

  goToState(index: number) {
    if (index >= 0) {
      
      // for (let i = index + 1; i < this.fields.length; i++) {
      //   if (this.form.get(this.fields[i].name)) {
      //     this.form.get(this.fields[i].name).setValue('');
      //   }
      // }


      let newIndex= index - 1;

      let valuesAfterIndex = this.valuesInputed.slice(newIndex + 1);

      console.log(valuesAfterIndex);

      let i=0;
      valuesAfterIndex.forEach(element => {

        this.form.get(element).setValue('');

        let indexForm = this.valuesInputed.findIndex(x => x ==element);

        if(indexForm>-1&&i>0){
          this.valuesInputed.splice(indexForm ,1);
        }
        i++;
      });
      
     // this.valuesInputed=  this.valuesInputed.splice(newIndex + 1);

     // this.valuesInputed = this.fields.slice(0, index + 1).map(field => field.name);
  
      if (index == 0) {
        this.valuesInputed = [this.fields[0].name];
        this.dontDisplayBackButton = false;
      }
  
      let name=this.valuesInputed[this.valuesInputed.length-1];
      let indexNew = this.fields.findIndex(x => x.name ==name);
  
      this.objectTobeDisplayed = this.fields[indexNew];
    }
  }
  

  submitSecondForm(value) {

    console.log(value);
    
    const mergedObj = { ...this.form.value, ...value };

    mergedObj.productListingImages = this.imageList;

    mergedObj['value'] = JSON.stringify(mergedObj);
    this.SubmitForm(mergedObj)


  }

  
  subscribeToFormChangesText() {
  

      this.subscriptionService.updateFormValue(this.form);
      
      this.updateConditionalFieldsVisibility();
   
  }


}